import React from 'react';
import ReactDOM from 'react-dom/client';
import { CssBaseline, ThemeProvider } from '@mui/material';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import theme from './theme';
import logoTitle from './assets/logo-title.png';

const faviconLink = document.querySelector("link[rel='icon']");
if (faviconLink) {
  faviconLink.setAttribute('href', logoTitle);
}

const appleTouchIcon = document.querySelector("link[rel='apple-touch-icon']");
if (appleTouchIcon) {
  appleTouchIcon.setAttribute('href', logoTitle);
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <App />
    </ThemeProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
//AppWrite hosted testing
reportWebVitals();
